import { useTranslation } from "react-i18next";
import { Linking, Pressable } from "react-native";
import { Text } from "react-native-paper";
import { useAppTheme } from "../../../useAppTheme";
import Box from "../../Box";

type Props = {
	privacyNoticeUrl?: string;
	mobileAppTermsUrl?: string;
};

export const LegalLinks = ({ privacyNoticeUrl, mobileAppTermsUrl }: Props) => {
	const { t } = useTranslation();
	const theme = useAppTheme();
	if (!(privacyNoticeUrl || mobileAppTermsUrl)) {
		return null;
	}

	return (
		<Box flexDirection="row" flexWrap="wrap" gap={4} paddingHorizontal={12}>
			{privacyNoticeUrl && (
				<Pressable
					onPress={() => Linking.openURL(privacyNoticeUrl)}
					accessibilityRole="link"
				>
					<Text
						variant="labelSmall"
						style={{ color: theme.colors.onSurfaceVariant }}
					>
						{t("navbar.privacy")}
					</Text>
				</Pressable>
			)}
			{privacyNoticeUrl && mobileAppTermsUrl && (
				<Text
					variant="labelSmall"
					style={{ color: theme.colors.onSurfaceVariant }}
				>
					·
				</Text>
			)}
			{mobileAppTermsUrl && (
				<Pressable
					onPress={() => Linking.openURL(mobileAppTermsUrl)}
					accessibilityRole="link"
				>
					<Text
						variant="labelSmall"
						style={{ color: theme.colors.onSurfaceVariant }}
					>
						{t("navbar.terms")}
					</Text>
				</Pressable>
			)}
		</Box>
	);
};
